var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitePauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5C12.6522 20.5 15.1957 19.4464 17.0711 17.5711C18.9464 15.6957 20 13.1522 20 10.5C20 7.84784 18.9464 5.3043 17.0711 3.42893C15.1957 1.55357 12.6522 0.5 10 0.5C7.34784 0.5 4.8043 1.55357 2.92893 3.42893C1.05357 5.3043 0 7.84784 0 10.5C0 13.1522 1.05357 15.6957 2.92893 17.5711C4.8043 19.4464 7.34784 20.5 10 20.5ZM8.75 8V13C8.75 13.6914 8.19141 14.25 7.5 14.25C6.80859 14.25 6.25 13.6914 6.25 13V8C6.25 7.30859 6.80859 6.75 7.5 6.75C8.19141 6.75 8.75 7.30859 8.75 8ZM13.75 8V13C13.75 13.6914 13.1914 14.25 12.5 14.25C11.8086 14.25 11.25 13.6914 11.25 13V8C11.25 7.30859 11.8086 6.75 12.5 6.75C13.1914 6.75 13.75 7.30859 13.75 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePauseIcon);
export default __webpack_public_path__ + "static/media/white_pause_icon.1d2ad78b4849efb8fa6ea97eaffa2b23.svg";
export { ForwardRef as ReactComponent };